import styled from 'styled-components';
import token from 'styled-token';
export var StyledPropertyCardHomeDetailsList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledPropertyCardHomeDetailsList",
  componentId: "c11n-8-111-1__sc-1j0som5-0"
})(["display:inline;list-style:none;margin:0;padding:0;li{display:inline;}&:not(:last-child):after,li:not(:last-child):after{content:' | ';color:", ";}"], token('colors.gray400'));